import { useMemo } from "react";
import Box from "@mui/material/Box";
import { GrupoModulo, ResultadoItem } from "./GrupoModulo";
import { useBuscadorGlobalStyles } from "./styles/BuscadorGlobalStyles";

const ResultadoLista = ({ resultados, onItemClick, labels = {} }) => {
  const classes = useBuscadorGlobalStyles();

  const { grupos, sinGrupo } = useMemo(() => {
    if (!resultados || resultados.length === 0) {
      return { grupos: [], sinGrupo: [] };
    }

    const gruposMap = {};
    const sinGrupo = [];

    resultados.forEach((item) => {
      if (item.tipo === "modulo") {
        if (!gruposMap[item.semCode]) {
          gruposMap[item.semCode] = {
            nombreModulo: item.titulo,
            icono: item.icono,
            semCode: item.semCode,
            items: [],
          };
        }
      } else if (item.tipo === "menu") {
        if (!gruposMap[item.semCode]) {
          gruposMap[item.semCode] = {
            nombreModulo: item.tituloModulo || item.semCode,
            icono: "",
            semCode: item.semCode,
            items: [],
          };
        }
        gruposMap[item.semCode].items.push(item);
      } else {
        sinGrupo.push(item);
      }
    });

    return { grupos: Object.values(gruposMap), sinGrupo };
  }, [resultados]);

  if (!resultados || resultados.length === 0) return null;

  return (
    <Box>
      {grupos.map((grupo) =>
        grupo.items.length > 0 ? (
          <GrupoModulo
            key={grupo.semCode}
            grupo={grupo}
            onItemClick={onItemClick}
            labelSinPermisos={labels.Et_SinPermisos}
          />
        ) : null,
      )}

      {sinGrupo.map((item, index) => (
        <ResultadoItem
          key={`sin-grupo-${index}`}
          item={item}
          onClick={onItemClick}
          labelSinPermisos={labels.Et_SinPermisos}
        />
      ))}
    </Box>
  );
};

export default ResultadoLista;
